module.exports = __webpack_public_path__ + "img/1470810484.94dd8f00.jpg";